// src/theme/components/paperStyles.js
const paperStyles = (theme) => ({
    MuiPaper: {
      styleOverrides: {
        root: {
          // Responsive padding
          padding: {
            xs: theme.spacing(2), // Less padding on mobile
            sm: theme.spacing(3),
            md: theme.spacing(4), // Original padding for desktop
          },
          // Responsive border radius
          borderRadius: {
            xs: theme.shape.borderRadius * 2, // Less rounded on mobile
            sm: theme.shape.borderRadius * 4,
            md: theme.shape.borderRadius * 6, // Original radius for desktop
          },
          // Better handling of content overflow
          overflow: "hidden",
        },
      },
      props: {
        elevation: 0, // Example: Set default elevation to 0
      },
  },
});

export default paperStyles;
